import { Hash, Landmark, Lock } from 'lucide-react';
import type { PublicSpace } from '@dove/shared';

/**
 * What a space looks like, in one place.
 *
 * THIS USED TO LIVE IN THE COMPOSER, and that was the right altitude for exactly
 * as long as the composer was the only surface that drew a space. Every post now
 * names its room (`PostData.space`), so a space is rendered in at least two places
 * that must agree, and the moment there were two the mapping drifted: a faith
 * space is not sealed and is not a topic, so a card inlining
 * `sealed ? Lock : Hash` drew a hash on the room the composer had just drawn a
 * landmark on. Same space, two glyphs, one tap apart.
 *
 * Adding a value to `SPACE_KIND` is now one edit rather than two, and the switch
 * below is exhaustive over the union, so the compiler names the file to change.
 */
export function spaceIcon(space: PublicSpace): typeof Hash {
  /* Sealed first, and it outranks the kind: the padlock is about who can SEE the
     room, which is the whole audience model, and it is the one thing a reader has
     to be able to tell at a glance. */
  if (space.sealed) return Lock;

  switch (space.kind) {
    /* General gets the hash a topic gets. It is not a topic — see `SPACE_KIND` —
       but it is the same KIND of room to look at: open, joinable, and not an
       institution. `Landmark` on the default room would read as a civic notice
       board. */
    case 'general':
    case 'topic':
      return Hash;
    case 'faith':
    case 'womens':
    case 'mens':
      return Landmark;
  }
}
